import styled from "styled-components";

export const Wrapper = styled.div`
  max-width: ${(props: { $mobile: boolean }) => props.$mobile ? "124px" : "207px"};
  height: fit-content;
 
  border-radius: 4px;
  border-top: 3px solid #1263DE;
  padding: 14px;
  background-color: #FFFFFF;
  gap: 4px;
  box-shadow: 2px 5px 7px gray ;
`;


export const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline
  height: 20px
`;

export const Title = styled.div`
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;

`;
export const SubTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px; 
  line-height: 20px; 
  color: #404040;
  margin-top: 6px;
`;